import request from "@/service";

//选调函管理分页
export function getTransferPage(params) {
  return request({
    url: `/study/class/enroll/pageTransferByParam`,
    method: "get",
    params
  });
}
// 获取选调函模板
export function getTransferTemplate(data) {
  return request({
    url: `/study/class/enroll/setUpTransferFile`,
    method: "post",
    data
  });
}

// 预览选调函
export function previewTransfer(data) {
  return request({
    url: `/study/class/enroll/previewTransferFile`,
    method: "post",
    data
  });
}
// 发布选调函
export function publishTransfer(data) {
  return request({
    url: `/study/class/enroll/publishTransferFile`,
    method: "post",
    data
  });
}
//
export function getLetterPage(params) {
  return request({
    url: `/study/class/fileLibrary/letterPage`,
    method: "get",
    params
  });
}










